module.exports = __webpack_public_path__ + "fonts/TBCSailec-Regular.3a678320.woff";